import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Link } from '@mui/material';
import MediaTypography from 'components/MediaTypography';
import store from 'store';

import { IResetPasswordData } from '@common/api/auth';
import FormField from '@common/components/FormField';
import { ROUTES } from '@common/constants/CampusRoutes';

import Layout from '../../components/Layout';
import schema, { SendEmailFormValues } from './schema';

function SendEmail() {
	const [email, setEmail] = useState(null);
	const [isSubmitted, setIsSubmitted] = useState(null);

	const navigate = useNavigate();

	const handleSubmit = async (values: IResetPasswordData) => {
		try {
			const token = await store.auth.resetPassword(values as IResetPasswordData);
			// setEmail(values.email.replace(/(?<=^[A-Za-z0-9]{2}).*?(?=@)/, '***'));
			setEmail(values.email);
			setIsSubmitted(token); // @TODO: Temporary. Token will be replaced to boolean
		} catch (e) {
			console.error('Reset Password Error', e);
			throw e;
		}
	};

	return isSubmitted ? (
		<Layout<SendEmailFormValues>
			header="Success!"
			headerText={`An email with a link to change your password has been sent to your e-mail ${email}`}
			buttonText="Log in"
			onSubmit={() => navigate(ROUTES.AUTH)}
			validationSchema={schema()}
		/>
	) : (
		<Layout<SendEmailFormValues>
			header="Password change"
			headerText="Enter your email to change your password"
			buttonText="Send"
			footer={
				<MediaTypography variant="body2" textAlign="center">
					I remembered&nbsp;
					<Link borderBottom="none" href={ROUTES.HOME}>
						Log in
					</Link>
				</MediaTypography>
			}
			initialValues={{
				email: '',
			}}
			onSubmit={handleSubmit}
			validationSchema={schema()}
		>
			<FormField label="E-mail*" type="text" name="email" />
		</Layout>
	);
}

export default observer(SendEmail);
